import React from "react";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

const ProductNotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        status="404"
        title="404"
        subTitle={t("productNotFound.subTitle")}
        extra={
          <div>
            <Button
              type="link"
              onClick={() => {
                window.location.href = "https://salespark.io";
              }}
            >
              {t("productNotFound.goToSiteButton")}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("productNotFound.retryButton")}
            </Button>
          </div>
        }
      />
    </>
  );
};

export default ProductNotFound;
